import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import { withStyles } from '@material-ui/core/styles'

import NewsContent from './NewsContent'
import { ArrowRight } from './Icons'
import { SmallText } from '../styleguide'

import buildAssetUrl from '../utils/buildAssetUrl'

const styles = () => ({
  containerStyle: {
    position: 'relative',
    paddingLeft: 16,
    display: 'flex',
    borderBottom: '1px solid #f0f1f2',
    borderRight: '1px solid #f0f1f2',
    '&:first-child': {
      borderTop: '1px solid #f0f1f2'
    }
  },
  itemUnreadStyle: {
    '&:before': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: '5px',
      bottom: 0,
      background: '#E40045',
      width: '6px',
      content: '""',
      display: 'block',
      borderBottom: '1px solid #fff'
    }
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    paddingBottom: '4px',
    width: '100%'
  },
  cardMediaWrapperStyle: {
    minWidth: 102,
    width: 102,
    height: 102,
    // backgroundColor: '#d8d8d8',
    margin: '10px 0'
  },
  cardContentStyle: {
    padding: '20px 16px 10px 16px'
  },
  cardActionStyle: {
    padding: '0 16px 4px 16px'
  }
})

const LinkItem = ({
  linkUrl,
  linkLabel,
  classes: { linkItemStyle, arrowStyle, linkStyle }
}) => (
  <div className={linkItemStyle}>
    <ArrowRight className={arrowStyle} size={12} />
    <Link to={linkUrl} className={linkStyle}>
      <SmallText>{linkLabel}</SmallText>
    </Link>
  </div>
)

const StyledLinkItem = withStyles(() => ({
  linkItemStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 8,
    cursor: 'pointer'
  },
  arrowStyle: {
    color: '#e40045'
  },
  linkStyle: {
    marginLeft: 2,
    textDecoration: 'none'
  }
}))(LinkItem)

const getImageComponent = image => {
  if (image) {
    const { type, url } = buildAssetUrl(image, 102)
    if (type === 'image') {
      return (
        <CardMedia
          image={url}
          style={{
            width: 102,
            minWidth: 102,
            height: 102
          }}
        />
      )
    }
  }
  return null
}

const NewsItem = ({
  headline,
  text,
  date,
  isUnread,
  linkUrl,
  linkLabel,
  teaserImage,
  classes: {
    containerStyle,
    itemUnreadStyle,
    contentStyle,
    cardMediaWrapperStyle,
    cardContentStyle,
    cardActionStyle
  }
}) => {
  const hasLink = linkUrl && linkLabel
  const image = getImageComponent(teaserImage)

  return (
    <Card
      elevation={0}
      square
      className={`${containerStyle} ${isUnread && itemUnreadStyle}`}
    >
      <div className={cardMediaWrapperStyle}>{image}</div>
      <div className={contentStyle}>
        <CardContent classes={{ root: cardContentStyle }}>
          <NewsContent
            date={date}
            headline={headline}
            text={text}
            isUnread={isUnread}
          />
        </CardContent>
        {hasLink && (
          <CardActions className={cardActionStyle}>
            <StyledLinkItem linkLabel={linkLabel} linkUrl={linkUrl} />
          </CardActions>
        )}
      </div>
    </Card>
  )
}

NewsItem.propTypes = {
  headline: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  isUnread: PropTypes.bool.isRequired,

  linkUrl: PropTypes.string,
  linkLabel: PropTypes.string
}

export default withStyles(styles)(NewsItem)



// WEBPACK FOOTER //
// ./src/components/NewsItem.js